import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Paper,
  Box,
  Button,
  Chip,
  Grid,
  CircularProgress,
  Alert
} from "@mui/material";
import { ArrowBack, AttachFile } from "@mui/icons-material";
import Dashboard from "./Dashboard";

function ApplicationDetail({ user }) {
  const { applicationId } = useParams();
  const navigate = useNavigate();
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchApplication();
  }, [applicationId]);

  const fetchApplication = async () => {
    try { 
      const response = await fetch(`${process.env.REACT_APP_API_URL}/applications/${applicationId}`, {
        credentials: "include"
      });
      
      if (response.ok) {
        const data = await response.json();
        setApplication(data);
      } else {
        setError("Application not found");
      }
    } catch (err) {
      setError("Error loading application");
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "accepted":
      case "approved":
        return "success";
      case "rejected":
      case "denied":
        return "error";
      case "submission_review":
      case "assessment_review":
        return "warning";
      default:
        return "default";
    }
  };

  const getAttachments = () => {
    if (!application?.attachments) return [];
    
    try {
      return typeof application.attachments === 'string' 
        ? JSON.parse(application.attachments)
        : application.attachments;
    } catch (e) {
      return application.attachments.split(',').filter(f => f);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Alert severity="error">{error}</Alert>
        <Button 
          startIcon={<ArrowBack />} 
          onClick={() => navigate('/applications')}
          sx={{ mt: 2 }}
        >
          Back to Applications
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Assessment Dashboard
            </Typography>
            <Dashboard 
              user={user} 
              applicationId={application.id}
              applicationData={application}
              onBack={() => navigate('/applications')}
              onAnalyze={() => { 
                navigate("/analyzeform", { state: { application: application } });
              }}
            />
          </Paper>
    </Container>
  );
}

export default ApplicationDetail;
